<template>
  <section class="create-alerts" id="main-wrap">
    <div class="content-wrapper">    
      <div class="container">
        <div class="heading-row">
          <h2 class="page-heading">Create alerts</h2>
        </div>
        <div class="upload-file">
          <form id="uploadForm" role="form" enctype='multipart/form-data' >
            <input type="file" id="file" name="file" ref="file" @change="onFileChange">
            <label class="custom-file-label" for="file">{{ fileName }}</label>
            <input type='button' value='Upload' @click="submitFile" class="upload-btn">
          </form> 
          <p class="validation-message"> {{ status }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CreateAlerts',
  data: function() {
    return { 
      file: '',
      status: '',
      fileName:'Upload a file...',
      postUrl:''
      }
  },
  components: {
    // FilePond
  },
 
  methods: {   
    submitFile() {
      let formData = new FormData();
      formData.append('file', this.$refs.file.files[0]);
      
      let config =  {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        };
      // You should have a server side REST API 
      //You should have a server side REST API
		  if (process.env.NODE_ENV == 'development') {
			  this.postUrl = 'http://172.16.153.161:8000/api/csv-data';
		  } else {
			  this.postUrl = 'https://alerts.rdxstg.host/api/csv-data';
      }
      axios.post(this.postUrl,
        formData,config
      )      
      .then(response => {        
        this.requestSubmitted = true;
        //console.log(response.data.status);
        switch (response.data.status) {
          case 'success':
            this.status = 'File uploaded successfully!';                    
          break;

          case 'filesizeerror':
            this.status = 'Maximum updaload file size: 2 MB.';
          break;
          
          case 'extensionerror':
            this.status = 'This is not a valid .csv file extension.';                    
          break;

          case 'error':
            this.status = 'Error in File Upload.';            
          break;
        
          default:
            // Error msg
            this.status = 'Error in File Upload.';            
          break;
        }
        
      })
      .catch(function (error) {
        console.log('FAILURE!!');
      });
    },  
    onFileChange() {
        const files = this.$refs.file.files[0];
        this.fileName = files.name;
    }
  },
}
</script>


